import template from "lodash/template";

export const getMemberSavingsText = (
  pageContent?: any,
  percentage: number = 0,
  minPercent?: number,
  maxPercent?: number
) => {
  const saveRangeSelect =
    pageContent?.SAVE_ON_SELECT_ITEMS ||
    "SAVE <%= minPercent %>% - <%= maxPercent %>% ON SELECT ITEMS";

  const saveRangeAll =
    pageContent?.SAVE_ON_ALL_ITEMS ||
    "SAVE <%= minPercent %>% - <%= maxPercent %>% ON ALL ITEMS";

  const saveOnSelectedItems =
    pageContent?.SAVE_SELECT_ITEMS || "SAVE <%= minPercent %>% ON SELECT ITEMS";

  const saveOnAllItems =
    pageContent?.SAVE_ALL_ITEMS || "SAVE <%= minPercent %>% ON ALL ITEMS";

  if (!minPercent && !maxPercent) return "";

  if (
    minPercent === maxPercent ||
    (minPercent && !maxPercent) ||
    (!minPercent && maxPercent)
  ) {
    if (percentage < 20) {
      return template(saveOnSelectedItems)({
        minPercent: minPercent || maxPercent
      });
    }
    if (percentage >= 20 && percentage < 100) {
      return template(saveOnSelectedItems)({
        minPercent: minPercent || maxPercent
      });
    }
    return template(saveOnAllItems)({ minPercent: minPercent || maxPercent });
  }

  if (percentage < 20) {
    return template(saveRangeSelect)({ minPercent, maxPercent });
  }
  if (percentage < 100) {
    return template(saveRangeSelect)({ minPercent, maxPercent });
  }
  return template(saveRangeAll)({ minPercent, maxPercent });
};
